<template>
  <div class="convey_box">
    <!--<HeadNavBar></HeadNavBar>-->
    <div v-if="is_id" class="nr_box">
      <Row class="banner_box">
        <div class="banner_title_box">
          <!-- <p class="banner_title">{{ web_name }}</p> -->
          <p class="case_status">{{ case_status }}</p>
        </div>
        <VanImage
          :src="require('@/assets/image/convey_banner_img.png')"
        />
      </Row>
      <Row class="pdf_box_bg">
        <Row
          v-for="(pdf_data_list_vale, index) in pdf_data_list"
          :key="index"
          class="van-doc-demo-block__card"
        >
          <ConveyPDF
            :list_index="index"
            :pdf_list_data="pdf_data_list_vale"
            @LoopRenderingPDF="LoopRenderingPDF"
          />
        </Row>
        <Row v-if="url_btn" class="sercice_btn_box">
          <a target="_blank" @click="Btn_clic()">
            <Button type="primary" color="#EB1212" block>确认签字</Button>
          </a>
        </Row>
      </Row>
    </div>
    <Row v-else class="is_id_box jz">
      <Loading size="40px" vertical>{{ is_id_text }}</Loading>
    </Row>
  </div>
</template>
<script>
import {
  Toast,
  NavBar,
  Loading,
  Image as VanImage,
  Col,
  Row,
  Tag,
  Cell,
  Button,
  CellGroup
} from 'vant'
import {
  fetchList,
  getaxios,
  getaxiosdata,
  deleteaxios,
  PostData,
  PostPut,
  updateArticle
} from '@/api/newarticle'
import HeadNavBar from '@/components/HeadNavBar/index'
import ConveyPDF from '@/components/ConveyPDF/index'
import axios from 'axios'
export default {
  name: 'Home',
  components: {
    Toast,
    Loading,
    ConveyPDF,
    HeadNavBar,
    NavBar,
    VanImage,
    Col,
    Row,
    Tag,
    Button,
    Cell,
    CellGroup
  },
  data() {
    return {
      url_btn: false,
      id: '',
      is_id: false,
      is_id_text: '加载中',
      htmlname: '',
      case_status: '',
      user_id: '',
      list_count: 1,
      ip_gps_os_data: '',
      caseInfoId: '',
      signRole: '',
      fileId: '',
      roleCode: '',
      name: '',
      pdf_data_list: [
        // {
        //     key:'应诉通知书',
        //     value:'http://dicszip.oss-cn-hangzhou.aliyuncs.com/a1e7062e-a28c-414c-8b0a-4875d298ef70.pdf'
        // },
        // {
        //     key:'应诉通知书',
        //     value:'http://dicszip.oss-cn-hangzhou.aliyuncs.com/d91a48da-56b9-4779-8936-7759c93764bb.pdf'
        // }
      ]
    }
  },
  computed: {
    web_name() {
      return this.$store.state.user.web_name
    }
  },
  created() {
    this.banner_title = this.$store.state.user.web_name
    // 改变body的背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f5f5f5')
    const id_list = this.$route.fullPath.split('?')
    if (id_list.length > 1) {
      this.id = id_list[1]
      this.direct()
    } else {
      this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
      Toast.fail('用户标识有误请检查')
    }
  },
  methods: {
    // 判断是不是手机端
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    replaceAll(str, preVal, replaceVal) {
      return str.replace(new RegExp(preVal, 'g'), replaceVal)
    },

    GetCurrentBrowser() {
      const ua = navigator.userAgent.toLocaleLowerCase()
      let browserType = null
      if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        browserType = 'IE'
      } else if (ua.match(/firefox/) != null) {
        browserType = 'firefox'
      } else if (ua.match(/ucbrowser/) != null) {
        browserType = 'UC'
      } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
        browserType = 'opera'
      } else if (ua.match(/bidubrowser/) != null) {
        browserType = 'baidu'
      } else if (ua.match(/metasr/) != null) {
        browserType = 'sougou'
      } else if (
        ua.match(/tencenttraveler/) != null ||
        ua.match(/qqbrowse/) != null
      ) {
        browserType = 'QQ'
      } else if (ua.match(/maxthon/) != null) {
        browserType = 'maxthon'
      } else if (ua.match(/chrome/) != null) {
        const is360 = this._mime(
          'type',
          'application/vnd.chromium.remoting-viewer'
        )
        if (is360) {
          browserType = '360'
        } else {
          browserType = 'chrome'
        }
      } else if (ua.match(/safari/) != null) {
        browserType = 'Safari'
      } else {
        browserType = 'others'
      }
      return browserType
    },

    _mime(option, value) {
      const mimeTypes = navigator.mimeTypes
      for (const mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
          return true
        }
      }
      return false
    },
    // 判断设备类型
    GetOs() {
      const sUserAgent = navigator.userAgent.toLocaleLowerCase()
      if (sUserAgent.indexOf('android') > -1) return 'Android'
      if (sUserAgent.indexOf('iphone') > -1) return 'iPhone'
      if (sUserAgent.indexOf('symbianos') > -1) return 'SymbianOS'
      if (sUserAgent.indexOf('windows phone') > -1) return 'Windows Phone'
      if (sUserAgent.indexOf('ipad') > -1) return 'iPad'
      if (sUserAgent.indexOf('ipod') > -1) return 'iPod'
      return navigator.platform
    },
    async addUserAction(user_id) {
      const gps_data = {
        position: sessionStorage.getItem('area'),
        checkIp: sessionStorage.getItem('gps_ip')
      }
      gps_data.clientType = this.$common.isEmpty(this._isMobile())
        ? '电脑'
        : '手机'
      gps_data.browser = this.GetCurrentBrowser()
      sessionStorage.setItem('ip_gps_os_data', JSON.stringify(gps_data))

      const data = gps_data
      gps_data.caseInfoId = user_id
      gps_data.identity = this.user_type == 'def' ? '30000162' : '30000161'
      await PostData(
        `/api/home/addUserAction`,
        gps_data
      ).then((response) => {})
    },
    Btn_clic() {
      this.$router.push(this.url_btn)
    },
    async direct() {
      const response = await getaxios(`/plaintiff/api/home/direct/${this.id}`)
      if (response.code == 200) {
        this.fileId = this.$common.UrlToJson('fileId', response.data.url)
        this.roleCode = this.$common.UrlToJson('roleCode', response.data.role)
        this.name = this.$common.UrlToJson('name', response.data.name)

        // let id_list = response.data.url.split("?");
        this.GetConveyPDF(this.fileId)
        this.url_btn = {
          path: '/signanew',
          query: {
            fileInfoId: this.fileId,
            signRole: this.roleCode,
            name: this.name
          }
        }

        // if (id_list.length > 1) {
        //   this.user_id = id_list[1];
        //   this.is_id = true;
        //   this.GetConveyPDF(id_list[1]);
        //   this.url_btn = `${requesturl.baseURL}/api/sign/trialHandImage.html?fileInfoId=${this.user_id}&signRole=${this.signRole}&name=${this.name}`;
        //   console.log(this.url_btn);
        //   // this.addUserAction(id_list[1]);
        // } else {
        //   Toast.fail("获取用户id失败");
        //   this.is_id_text = "无法正确获取到用户id,请勿修改网页链接参数";
        // }
      } else {
        Toast.fail('获取用户id失败')
        this.is_id_text = '无法正确获取到用户id,请勿修改网页链接参数'
      }
    },
    async GetConveyPDF(fileId) {
      this.is_id = true

      await getaxios(`/admin/api/sign/home/getSignPdf/${fileId}`).then((response) => {
        if (response.code == 200) {
          // this.banner_title = response.data.caseCode
          // this.case_status = response.data.caseCode;
          this.case_status = '文书签字'
          // response.data.files.length = 3
          this.pdf_tabs_list = [
            { value: response.data.filePath, key: response.data.fileName }
          ]
          for (const i in this.pdf_tabs_list) {
            this.pdf_tabs_list[i].name = i
          }
          // 循环加载PDF每次只加载三个避免渲染太卡
          for (const pdf_tabs_list_index in this.pdf_tabs_list) {
            if (pdf_tabs_list_index <= this.list_count) {
              this.pdf_data_list.push(this.pdf_tabs_list[pdf_tabs_list_index])
            }
          }
        } else {
          Toast.fail('获取文书失败')
          this.is_id_text = '无法正确获取到相关文书,请勿修改网页链接参数'
        }
      })
    },
    LoopRenderingPDF() {
      window.isconnon.platablefuncre(this)
    }
  }
}
</script>
<style lang="less" scoped>
.sercice_btn_box {
  padding: 20px 10px 30px;
}
.van-doc-demo-block__card {
  padding: 10px 0;
}
.is_id_box {
  text-align: center;
  font-size: 20px;
  line-height: 1.5;
}
.van-tab__pane {
  width: auto;
  margin: 20px;
  background-color: #fff;
  border-radius: 12px;
  flex-shrink: 0;
  box-sizing: border-box;
}
.convey_box {
  background: rgba(245, 245, 245, 1);
}
.pdf_box_bg {
  height: 100%;
}
.van-doc-demo-block__card {
  margin: 0 12px 0;
  overflow: hidden;
  border-radius: 8px;
}
.banner_box {
  position: relative;
  .banner_title_box {
    margin-left: 28px;
    margin-top: 40px;
    position: absolute;
    z-index: 10;
    color: #fff;
    .banner_title {
      font-size: 18px;
      margin-bottom: 16px;
    }
    .case_status {
      margin: 0;
      font-size: 17px;
    }
  }
}
</style>
